import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { redirectLegacySettings } from "./settingsCatalog";
export const LegacySettingsRedirect = () => { const { pathname, search, hash } = useLocation(); return <Navigate replace to={redirectLegacySettings(pathname, search, hash) || "/settings"} />; };
